<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24">
          <Tabs v-model="currentRoute" @on-click="changeRouter">
            <TabPane v-for="tab in tabs" :key="tab.name" :name="tab.name" :label="tab.label"></TabPane>
            <Refresh slot="extra"></Refresh>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <keep-alive :max="20">
          <router-view v-if="mapRou" :key="$route.path" />
        </keep-alive>
      </div>
    </Content>
  </Layout>
</template>
<script>
import { mapGetters } from 'vuex'
import Refresh from '@/components/converter/refresh.vue'

export default {
  name: 'imain',
  components: { Refresh },
  watch: {
    $route(route) {
      this.currentRoute = route.name
    }
  },
  computed: {
    mapRou() {
      const { name, params } = this.$route
      return params && params.id && ['account', 'group', 'plan', 'idea'].includes(name)
    },
    tabs() {
      const media = Number(this.$route.params.id)
      if (media === 6) {
        return this.tabsUc
      } else if (media === 10) {
        return this.tabsTouTiao
      } else if (media === 16) {
        return this.tabsTencent
      } else if (media === 45) {
        return this.tabsBaidu
      } else if (media === 32) {
        return this.tabsKS
      } else {
        return this.tabsTouTiao
      }
    }
  },
  data() {
    return {
      currentRoute: this.$route.name,
      tabsTouTiao: [
        { name: 'account', label: '账号' },
        { name: 'group', label: '计划组' },
        { name: 'plan', label: '投放计划' },
        { name: 'idea', label: '创意' }
      ],
      tabsUc: [
        { name: 'account', label: '账号' },
        { name: 'group', label: '推广组' },
        { name: 'plan', label: '推广计划' },
        { name: 'idea', label: '创意' }
      ],
      tabsTencent: [
        { name: 'account', label: '账号' },
        { name: 'group', label: '推广计划' },
        { name: 'plan', label: '计划' },
        { name: 'idea', label: '创意' }
      ],
      tabsBaidu: [
        { name: 'account', label: '账号' },
        { name: 'group', label: '推广计划' },
        { name: 'plan', label: '推广单元' },
        { name: 'idea', label: '创意' }
      ],
      tabsKS: [
        { name: 'account', label: '账号' },
        { name: 'group', label: '推广计划' },
        { name: 'plan', label: '计划组' },
        { name: 'idea', label: '创意' }
      ]
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.replace({ name })
    }
  }
}
</script>
<style lang="scss" scoped></style>
